/// <reference path="../../../.tmp/typings/tsd.d.ts" />
"use strict";
var CurrentlyOpenModals = (function () {
    function CurrentlyOpenModals() {
        this.openModals = [];
    }
    CurrentlyOpenModals.prototype.modalOpened = function (modal) {
        this.openModals.push(modal);
    };
    CurrentlyOpenModals.prototype.modalClosed = function (modal) {
        this.openModals.splice(this.openModals.indexOf(modal), 1);
    };
    return CurrentlyOpenModals;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = CurrentlyOpenModals;



//////////////////
// WEBPACK FOOTER
// ./src/components/base/currentlyopenmodals.service.ts
// module id = 4
// module chunks = 0